import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import { ConfirmModal } from "../../../ConfirmModal";
import { toast } from "react-toastify";
import { handleApi } from "../../../../utils/authentication";

const InternalCampaignModal = ({
  show,
  setShow,
  internalCampaigns,
  externalCampaign,
  setShowUnassociatedCampainModal
}) => {
  const headers = [
    { label: "Name", key: "name" },
    { label: "Start Date", key: "startDate" },
    { label: "End Date", key: "endDate" },
    { label: "Actions", key: "actions" },
  ];
  const [linking, setLinking] = useState();
  const [internalCamplainSelected, setInternalCamplainSelected] = useState({});
  const [showConfirmLinkingModal, setShowConfirmLinkingModal] = useState(false);


  const handleLinkingCampaign = async (currentIndex, campaign) => {
    setInternalCamplainSelected(campaign);
    setShowConfirmLinkingModal(true);
  };

  const handleOnConfirm=async()=>{
    try {
      //link internal campaign to linkedin campaign
      setLinking(true);

      let formData = new FormData();
      formData.append("campaign_id", parseInt(internalCamplainSelected?.campaign_id));
      formData.append("platform_id", 2);
      formData.append("linkedin_campaign_id", parseInt(externalCampaign?.linkedin_campaign_id));
      formData.append("is_mapped", externalCampaign?.is_mapped);

      let result = await handleApi(
        "update_campaign_associate_status",
        "POST",
        {},
        formData
      );
      if (result?.success) {
       
        setShow(false);
        setShowUnassociatedCampainModal(false)
        toast.success(result?.message);
      } else {
        toast.error(result?.error?.error_message||'Error linking campaign');
      }
      setLinking(false);
    } catch (e) {
      setLinking(false);

      console.log(e);
      toast.error(e?.message);
    }
    
  }
  return (
    <div>
      <Modal
        show={show}
        onHide={() => {
          setShow(false);
        }}
        size="xl"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
       
          <div className="d-flex flex-column gap-1">
            <span className="fs-4 fw-bold">
              Link with campaigns on UI platform
            </span>
            <small className="fs-8">
              Select an internal campaign to link with your chosen Linkedin Ads campaign.
            </small>
          </div>
        </Modal.Header>
        <Modal.Body className="overflow-auto" style={{ height: "50vh" }}>
          <div className="card-lg bg-light">
            <div className="table-responsive text-nowrap card-body py-0">
              <table className="table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4 table-auto m-0">
                <thead>
                  <tr className="fw-bold text-muted bg-light">
                    {headers.map((header) => (
                      <th className={`min-w-100px ${header.label==='Actions'&&'text-end'}`} key={header.key}>
                       {header.label}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {internalCampaigns?.length === 0 ? (
                    <tr>
                      <td colSpan={headers.length} className="text-center text-muted">
                        No data available
                      </td>
                    </tr>
                  ) : (
                    internalCampaigns?.map((campaign, index) => {
                      // Use `index` from map as the unique identifier for the row.
                      return (
                        <tr key={campaign?.campaign_id}>
                          <td>{campaign?.campaign_name}</td>
                          <td>{campaign?.start_date}</td>
                          <td>{campaign?.end_date}</td>
                          <td className="d-flex justify-content-end">
                            <button
                              className="btn btn-sm rounded-pill btn-primary gap-1 d-flex align-items-center justify-content-center"
                              style={{ width: "150px" }}
                              onClick={async () => {
                                // handleLinkingCampaignn is called with the current index and campaign data
                                handleLinkingCampaign(index, campaign);
                              }}
                              disabled={linking} // Use `index` to track the loading state for each row
                            >
                              <span>Link</span>
                            </button>
                          </td>
                        </tr>
                      );
                    })
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </Modal.Body>

      </Modal>
      <ConfirmModal
        show={showConfirmLinkingModal} 
        onClose={()=>setShowConfirmLinkingModal(false)} 
        title={"Link with campaigns on UI platform"} 
        body={"Are you sure you want to connect google campaign to a platform campaign?"} 
        closeBtnTitle={"Cancel"} 
        submitBtnTitle={"Continue"} 
        onSubmit={handleOnConfirm} 
        loadingOnsubmit={linking}
    />

    </div>
  );
};

export default InternalCampaignModal;
